/**
 * Type for setting the user's consent for unsafe room joining.
 *
 * {
 *     type: SET_UNSAFE_ROOM_CONSENT,
 *     consent: boolean
 * }
 */
export const SET_UNSAFE_ROOM_CONSENT = 'SET_UNSAFE_ROOM_CONSENT'